import React from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';

const NoResult = ({ className, message }) => (
  <div className={`no-result text-center ${className}`}>
    <I18N tag="p">{message}</I18N>
  </div>
);

NoResult.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string.isRequired,
};

NoResult.defaultProps = {
  className: 'col-sm-12',
};

export default NoResult;
